import { adminRoles, userRoles } from '@/constant/role'
import { ADMIN_ROUTES } from '@/features/admin/routes'
import { useAuthContext } from '@/features/auth/context'
import useUser from '@/features/auth/hooks/useUser'
import { type ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import LoadingScreen from '../common/LoadingScreen'
import { OPERATIONS_ROUTES } from '@/constant/route'

type Props = {
  children: ReactElement
}

const RequireIsAnonymous = ({ children }: Props) => {
  const { isLogin } = useAuthContext()
  const { data: user, isLoading, isError } = useUser()

  if (!isLogin || isError) return children

  if (isLoading) return <LoadingScreen />

  // Hardcode redirect for specific user to Sensor Dashboard (SCRUM-826)
  if (user?.email === 'rodney_mckeown@sentosagolf.com') {
    return <Navigate replace to={OPERATIONS_ROUTES.sensors.to} />
  }

  if (adminRoles.includes(user?.role)) {
    return <Navigate replace to={ADMIN_ROUTES.index.to} />
  }

  if (userRoles.includes(user?.role)) {
    return <Navigate replace to={OPERATIONS_ROUTES.index.to} />
  }

  return null
}

export default RequireIsAnonymous
